import styled, { css } from 'styled-components';

export const Section = styled.section`
  ${({ theme, ...props }) => {
    return css`
      background: ${theme.color.white};
      padding: ${theme.spacing.md};

      @media screen and (min-width: ${theme.breakpoint.sm}) {
        padding: ${theme.spacing.xl} ${theme.spacing.md};
      }

      // Container
      > div {
        > h2,
        > h4 {
          @media screen and (max-width: ${theme.breakpoint.sm}) {
            font-size: ${theme.typography.font_size.title_xl};
          }
        }
      }
    `;
  }};
`;

export const CarrouselWrapper = styled.div`
  ${({ theme, ...props }) => {
    return css`
      position: relative;
      padding: 2rem 0;
      .swiper {
        .swiper-wrapper {
          .swiper-slide {
          }
        }
      }
    `;
  }};
`;
